import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useState, useMemo, useCallback } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var HiddenIcon = function HiddenIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.97061 5.9707C3.91622 7.51605 2.78472 9.58428 2.26984 10.7408C1.91137 11.546 1.91189 12.4557 2.27016 13.2603C3.13949 15.2126 5.89161 20.0002 12.0004 20.0002C14.5418 20.0002 16.5261 19.1608 18.0298 18.0299L16.598 16.5981C15.435 17.4109 13.9345 18.0002 12.0004 18.0002C7.14513 18.0002 4.89019 14.2276 4.09721 12.4468C3.96927 12.1594 3.96927 11.841 4.09694 11.5542C4.55783 10.519 5.55495 8.73224 7.30857 7.46911C7.33982 7.4466 7.36939 7.42262 7.39724 7.39733L5.97061 5.9707Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.1716 9.17139C8.44888 9.89421 8 10.8952 8 11.9998C8 14.209 9.79086 15.9998 12 15.9998C13.1047 15.9998 14.1056 15.5509 14.8284 14.8282L13.4142 13.414C13.0513 13.7771 12.5522 13.9998 12 13.9998C10.8954 13.9998 10 13.1044 10 11.9998C10 11.4476 10.2227 10.9485 10.5858 10.5856L9.1716 9.17139Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.0003 4C18.1092 4 20.8611 8.78782 21.7302 10.7401C22.0885 11.5448 22.0885 12.4552 21.7302 13.2599C21.5746 13.6096 21.3658 14.0352 21.0963 14.5009C20.8197 14.9789 20.208 15.1421 19.7299 14.8655C19.2519 14.5889 19.0887 13.9772 19.3653 13.4991C19.5948 13.1025 19.7722 12.7407 19.9031 12.4465C20.0309 12.1595 20.0309 11.8405 19.9031 11.5535C19.1103 9.77274 16.8556 6 12.0003 6L11 6.00001C10.4477 6.00001 10 5.5523 10 5.00002C9.99999 4.44773 10.4477 4.00001 11 4.00001L12.0003 4Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.29289 2.29289C2.68342 1.90237 3.31658 1.90237 3.70711 2.29289L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L2.29289 3.70711C1.90237 3.31658 1.90237 2.68342 2.29289 2.29289Z",
      fill: "#12131A"
    })]
  }));
};

HiddenIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var VisibleIcon = function VisibleIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0002 6C7.14499 6 4.89006 9.77258 4.09708 11.5534C3.96927 11.8405 3.96927 12.1595 4.09708 12.4466C4.89006 14.2274 7.14499 18 12.0002 18C16.8555 18 19.1103 14.2273 19.9031 12.4465C20.0309 12.1595 20.0309 11.8405 19.9031 11.5535C19.1103 9.77274 16.8555 6 12.0002 6ZM2.27002 10.7399C3.13935 8.78756 5.89147 4 12.0002 4C18.1091 4 20.861 8.78782 21.7302 10.7401C22.0885 11.5448 22.0885 12.4552 21.7302 13.2599C20.861 15.2122 18.1091 20 12.0002 20C5.89147 20 3.13935 15.2124 2.27002 13.2601C1.91162 12.4552 1.91162 11.5448 2.27002 10.7399Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM11.9153 10.0018C11.9434 10.0006 11.9716 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 11.9716 10.0006 11.9434 10.0018 11.9153C10.1577 11.9701 10.3253 12 10.5 12C11.3284 12 12 11.3284 12 10.5C12 10.3253 11.9701 10.1577 11.9153 10.0018Z",
      fill: "#12131A"
    })]
  }));
};

VisibleIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const FieldsRevealSection = _ref => {
  let {
    label,
    elementId = '',
    className = '',
    initialOpen = false,
    variant: srcVariant,
    onClick = () => null,
    children
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(initialOpen); // Create optional variant classes for container

  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`container--${variant}`]);
  }, [srcVariant]); // Toggle open/close and emit on click

  const handleClick = useCallback(() => {
    const update = !isOpen;
    setIsOpen(update);
    onClick(update);
  }, [onClick, isOpen, setIsOpen]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, className, isOpen ? styles['container--open'] : '', ...variantClasses),
    children: [/*#__PURE__*/_jsxs("span", {
      className: styles.heading,
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.heading__text,
        children: label
      }), /*#__PURE__*/_jsxs("button", {
        className: styles.heading__button,
        type: "button",
        children: [isOpen ? 'Hide' : 'Show', isOpen ? /*#__PURE__*/_jsx(HiddenIcon, {}) : /*#__PURE__*/_jsx(VisibleIcon, {})]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: isOpen && children
    })]
  }));
};

export default FieldsRevealSection;